import { CreateProjectDto } from '@mottmac-moata/identity-sdk';
import projectFormSchema from '../schema';

export const isCreateProjectDto = (data: unknown): data is CreateProjectDto =>
  projectFormSchema.safeParse(data).success;
